import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Typography,
  Paper,
} from "@mui/material";

const AccountTransferView = ({ open, onClose, data }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ bgcolor: "#0f4c81", color: "#fff" }}>
        Account Transfer View
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Paper sx={{ p: 2 }}><Typography variant="body2">Transfer Amount</Typography><Typography variant="h6">{data?.amount ?? "-"}</Typography></Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper sx={{ p: 2 }}><Typography variant="body2">Status</Typography><Typography variant="h6">Completed</Typography></Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper sx={{ p: 2 }}><Typography variant="body2">Currency</Typography><Typography variant="h6">{data?.from_account_currency_title || "-"}</Typography></Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper sx={{ p: 2 }}><Typography variant="body2">Exchange Rate</Typography><Typography variant="h6">{data?.exchange_rate ?? "-"}</Typography></Paper>
            </Grid>
          </Grid>

          <Paper sx={{ mt: 2, p: 2 }}>
            <Grid container spacing={1}>
              {[
                ["Transfer Number", data?.id ? `TR-${data.id}` : "-"],
                ["From Account", data?.from_account_name || "-"],
                ["To Account", data?.to_account_name || "-"],
                ["Amount", data?.amount ?? "-"],
                ["Transfer Date", data?.transfer_date || "-"],
                ["Reference", data?.reference || "-"],
              ].map(([k, v]) => (
                <Grid item xs={12} md={6} key={k}>
                  <Typography variant="body2"><strong>{k}:</strong> {v}</Typography>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountTransferView;
